// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"1c6adf9d","204":"0509a912","264":"fc2ccbdc","488":"af3561c1","619":"9c82ca39","638":"c1b45fe7","783":"9c7beb56"}[chunkId] + ".chunk.js";
};